import React from 'react';
import PageTemplate from '../../templates/PageTemplate';
import BrandAbout from './BrandAbout/BrandAbout';
import BrandInfo from './BrandInfo/BrandInfo';
import BrandForm from './BrandForm/BrandForm';

const Brandsupport = () => {
  return (
    <PageTemplate header="absolute">
      <BrandAbout />
      <BrandInfo />
      <BrandForm />
    </PageTemplate>
  );
};

export default Brandsupport;
